import { useNamespace, useStripes } from '@folio/stripes/core';
import { useQuery } from 'react-query';
import useTenantKy from './useTenantKy';

export default function useInstance(instanceId) {
  const {
    okapi: { tenant },
  } = useStripes();

  const ky = useTenantKy({ tenantId: tenant });
  const [namespace] = useNamespace({ key: 'instance' });

  const {
    isLoading,
    isError,
    data = {},
    refetch,
    ...rest
  } = useQuery(
    [namespace, instanceId, tenant],
    () => ky.get(`inventory/instances/${instanceId}`).json(),
    {
      enabled: Boolean(instanceId),
    },
  );

  return {
    instance: data,
    isInstanceLoading: isLoading,
    isError,
    refetch,
    ...rest,
  };
}
